import { Pipe, PipeTransform } from '@angular/core';
import { WarehouseService } from '../../common/_services';

@Pipe({
  name: 'datawarehouse',
  pure: true,
  standalone: false,
})
export class DatawarehousePipe implements PipeTransform {
  constructor(private warehouseService: WarehouseService) {}

  transform(value: any): any {
    if (!value) {
      return null;
    }

    const selected = this.warehouseService.getLocalWarehouseById(+value);
    if (selected) {
      return selected;
    } else {
      return null;
    }
  }
}
